/**
 * Created by Adam on 28/02/2017.
 */
if (window.jQuery) {
    window.jQuery(function ($) {
        var isAdminPage=$('body.wp-admin');
        if (isAdminPage.length===0)
        {
            var adBlockFlag = document.createElement('div');
            adBlockFlag.innerHTML = '&nbsp;';
            adBlockFlag.className = 'adsbox';
            $('body').append(adBlockFlag);
            window.setTimeout(function () {
                if (adBlockFlag.offsetHeight === 0) {
                    trackCTANoInteraction('ad_block_on', null);
                }
                adBlockFlag.remove();
            }, 100);
        }
    });
} else TCT.jQueryWarning();